import Config from '../Config';
import RequestRabbit from './RequestRabbit';

const useCountryRequest = () => {
  const getCountries = async (errorHandler, notCodes = false) => {
    return await RequestRabbit.get('/country/list', { notCodes }, errorHandler);
  };

  const getCountry = async (country_id, errorHandler) => {
    const url = `${Config.baseServerURL}/country/${country_id}`;
    const options = {
      method: 'GET',
    };
    const response = await RequestRabbit.request(url, options, errorHandler);
    if (response.status > 399 && response.status < 600) return [];

    const responseJSON = await response?.json();
    return responseJSON;
  };

  return {
    getCountries,
    getCountry,
  };
};

export default useCountryRequest;
